import angular from 'angular';
import qs from 'querystring';
import { updateUser } from '../../store/features/system/action-creators';
import { AngularServices } from '../../modules/core';
/* @ngInject */
function Auth($window, $q, $http, User, LoopBackAuth, apiUrl, institutionHelper, UserIdentity, routerHelperFactory, trackingFactory, Browser, $ngRedux) {
    let loginPopup = null;
    let loginDeferred = null;
    function err(message) {
        loginDeferred.reject({
            data: {
                error: {
                    message,
                },
            },
        });
    }
    function saveCurrentUser(payload) {
        if (payload.id && payload.userId && payload.user) {
            trackingFactory.trackSignIn(payload.user);
            LoopBackAuth.setUser(payload.id, payload.userId, payload.user);
            LoopBackAuth.rememberMe = true;
            LoopBackAuth.save();
        }
    }
    function receiveMessage(event) {
        // added for originalEvent => BaseJQueryEventObject
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const origin = event.origin || event.originalEvent.origin;
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        const action = event.data.action || '';
        if (action !== 'doxyme-auth') {
            return;
        }
        if (origin !== apiUrl && loginDeferred !== null) {
            loginDeferred.reject();
            return;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        const payload = event.data.payload || undefined;
        if (Boolean(payload) && payload.error) {
            console.error('Auth error:', payload.error);
            err(payload.error);
        }
        else {
            saveCurrentUser(payload);
            loginDeferred.resolve(payload);
        }
    }
    function openPopup(provider, params) {
        if (loginDeferred) {
            console.warn('Login() called during pending login...');
            if (loginPopup !== null && !loginPopup.closed) {
                loginPopup.focus();
                return loginDeferred.promise;
            }
        }
        const width = 1000;
        const height = 650;
        const left = $window.screen.width / 2 - width / 2;
        const top = $window.screen.height / 2 - height / 2;
        let authUrl = `${apiUrl}/auth/${provider}`;
        return institutionHelper
            .getCurrentInstitution()
            .then((institution) => {
            if (Object.keys(institution).length > 0) {
                params.institutionId = institution.id;
            }
            const query = qs.stringify(params);
            if (query) {
                authUrl += `?${query}`;
            }
            loginPopup = $window.open(authUrl, '_blank', 'toolbar=no,location=no,directories=no,status=no,menubar=no,' +
                `scrollbars=no,resizable=no,copyhistory=no,width=${width},height=${height},` +
                `top=${top},left=${left}`);
            loginDeferred = $q.defer();
            return loginDeferred.promise.finally(() => {
                loginPopup = null;
                loginDeferred = null;
            });
        });
    }
    window.addEventListener('message', receiveMessage, false);
    return {
        // This is intended to set a cookie on the api side that will then let identify user
        // on the api side without access token (required for third-party login for instance)
        // Using $http because lb services don't really let to set options per request
        // (like, here we need to use this 'withCredentials' in order to set cookie)
        rememberAuthState(scope = 'provider-auth') {
            return $http
                .get(`${apiUrl}/api/users/${User.getCurrentId()}/rememberAuthState`, {
                withCredentials: true,
                params: { scope },
            })
                .catch((error) => {
                console.error('RememberAuthState error:', error);
            });
        },
        rememberInstitutionAuthState(institution) {
            const id = typeof institution === 'string' || typeof institution === 'number'
                ? institution
                : institution.id;
            return $http
                .get(`${apiUrl}/api/institutions/${id}/rememberAuthState`, {
                withCredentials: true,
            })
                .catch((error) => {
                console.error('RememberInstitutionAuthState error:', error);
            });
        },
        checkInstitutionAuthState(institution) {
            const id = typeof institution === 'string' ? institution : institution.id;
            return $http
                .get(`${apiUrl}/api/institutions/${id}/checkAuthState`, {
                withCredentials: true,
            })
                .then((res) => {
                saveCurrentUser(res.data);
                return res.data;
            })
                .catch((error) => {
                console.error('CheckInstitutionAuthState error:', error);
            });
        },
        loginWithProvider(provider, params = {}) {
            return openPopup(provider, { ...params, ...Browser.getSystemInfo() });
        },
        linkProvider(provider, params = {}) {
            params.action = 'link';
            const user = User.getCachedCurrent();
            return this.rememberAuthState()
                .then(() => openPopup(provider, params))
                .then((identity) => {
                user.identities.push(identity);
                $ngRedux.dispatch(updateUser({ identities: user.identities }));
                return identity;
            });
        },
        unlinkProvider(provider) {
            const user = User.getCachedCurrent();
            const identity = user.identities.find((providerItem) => providerItem.provider === provider);
            return UserIdentity.deleteById({ id: identity.id })
                .$promise.then(() => {
                user.identities.splice(user.identities.indexOf(identity), 1);
                $ngRedux.dispatch(updateUser({ identities: user.identities }));
                return null;
            })
                .catch((error) => {
                console.error('UnlinkProvider error:', error);
            });
        },
        clearCurrentUser() {
            LoopBackAuth.clearStorage();
            LoopBackAuth.clearUser();
        },
    };
}
export default angular
    .module('doxy.common.services.auth', [])
    .factory(AngularServices.Auth, Auth).name;
